import { Component, EventEmitter, Output } from '@angular/core';
import { ManualSetupState } from '../store/manual_setup_state';
import { Store } from '@ngrx/store';
import { AccordionItem } from '../accordion_item';
import { manualChangeOpenState, manualCloseAll } from '../store/manual_setup_actions';
import { REDCRSS_EVENTS } from '../../../../../shared/services/constants/redcross_evemts';
import { IAppState } from '../../../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-accordion',
  template: require('./accordion.component.html'),
  styles: [require('./accordion.component.scss')]
})

export class AccordionComponent {
  accordionItems: Array<AccordionItem> = [];

  @Output() item: any = new EventEmitter();

  constructor(private store: Store<IAppState>, private redcrossService: AnalyticsTrackingProvider) {
    this.redcrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, {
      pageCategory: 'Installation V2'
    });

    this.store.select(state => state.app.install.manualSetup).subscribe(
      (items: ManualSetupState) => {
        this.accordionItems = items.accordionItems;
      }
    );
  }

  changeActiveItemState(activateItem: AccordionItem) {
    this.store.dispatch(manualCloseAll());
    this.store.dispatch(manualChangeOpenState({itemToChange: activateItem}));
  };

  openNext(activateItem: AccordionItem) {
    this.changeActiveItemState(activateItem.nextItem);
  }

  itemId(_index, item) {
    return item.id;
  }
}
